import styles from './Cell.module.css';

interface CellProps {
  score?: number;
}

const style = (score?: number) => {
  if (!score) {
    return {};
  }

  if (score <= -1) {
    return {
      backgroundColor: `rgb(255, 0, 50)`,
      color: 'white',
    };
  }

  const alpha = score / 100;

  return {
    backgroundColor: `rgba(22, 104, 137, ${alpha})`,
    ...(alpha >= 0.6 ? { color: 'white' } : {}),
  };
};

const ScoreCell: React.FC<CellProps> = ({ score = 0, children, ...props }) => (
  <div className={styles.cell} style={style(score)} {...props}>
    <span className={styles.label}>{children}</span>
  </div>
);

export default ScoreCell;
